import { Language } from '@rover/constants/src/i18n/lingui.constants';
import type { ServiceLandingPathDescriptor } from '@rover/shared/js/hooks/useServiceLanding';
import {
  type CountryUrlPrefix,
  COUNTRY_URL_PREFIXES_REGEX_PATTERN,
  getCountryUrlPrefix,
  getDefaultShortLanguageByUrlPrefix,
  getShortLanguagesByUrlPrefix,
  US_COUNTRY_URL_PREFIX,
} from '@rover/utilities/roverGeo.constants';

const SERVICE_LANDING_REGEX = new RegExp(
  `^(?:/(?<country_url_prefix>${COUNTRY_URL_PREFIXES_REGEX_PATTERN})(?:/(?<language_candidate>[a-z]{2}))?)?/(?<service_landing_slug>[a-z-]+)/`
);

export const findLanguageFromPath = (
  path: string,
  countryUrlPrefix: CountryUrlPrefix
): Language | undefined => {
  const candidate = SERVICE_LANDING_REGEX.exec(path)?.groups?.language_candidate;
  if (!candidate) return undefined;
  const validLanguages = getShortLanguagesByUrlPrefix(countryUrlPrefix);
  return validLanguages.includes(candidate as Language) ? (candidate as Language) : undefined;
};

const parseRoverServiceLandingPath = (path: string): ServiceLandingPathDescriptor => {
  const serviceLandingSlug = SERVICE_LANDING_REGEX.exec(path)?.groups?.service_landing_slug;
  if (!serviceLandingSlug) {
    throw new Error(`Could not parse service landing slug from path: ${path}`);
  }
  const countryUrlPrefix = getCountryUrlPrefix(path) ?? US_COUNTRY_URL_PREFIX;
  const language =
    findLanguageFromPath(path, countryUrlPrefix) ??
    getDefaultShortLanguageByUrlPrefix(countryUrlPrefix);
  return { countryUrlPrefix, serviceLandingSlug, language };
};

export default parseRoverServiceLandingPath;
